export const DEFAULT_COMMON_PROPS_TAB_TITLE = 'Properties';

export const DEFAULT_WEEKDAYS_SCHEDULE_TITLE = 'Weekdays Schedule';
export const DEFAULT_WEEKENDS_SCHEDULE_TITLE = 'Weekends Schedule';
export const DEFAULT_ALL_DAYS_SCHEDULE_TITLE = 'Schedule for All Days';
